function StatusWidget({
  statusText,
  presence,
  activity,
}: {
  statusText?: string | null;
  presence: 'online' | 'idle' | 'dnd' | 'offline' | 'mobile';
  activity?: string | null;
}) {
  const hasText = !!(statusText && statusText.trim().length);
  // Always show explicit status text if provided, even when offline.
  if (!hasText && presence === 'offline') return null;
  const label: string | null = (() => {
    if (hasText) return statusText!.trim();
    if (activity && activity.trim()) return activity.trim();
    // Nothing written: don't show a placeholder for online/mobile — the presence
    // dot already conveys availability.
    if (presence === 'online' || presence === 'mobile') return null;
    if (presence === 'idle') return 'Idle';
    return 'Offline';
  })();
  if (!label) return null;
  const color = presence === 'dnd'
    ? 'text-red-400'
    : presence === 'idle'
    ? 'text-amber-400'
    : presence === 'mobile'
    ? 'text-sky-400'
    : presence === 'online'
    ? 'text-online-light'
    : 'text-fg-2';
  return (
    <div
      className={`text-meta leading-4 ${color} break-words [overflow-wrap:anywhere]`}
      title={label}
      role="status"
      aria-label={`Status: ${label}`}
      tabIndex={0}
    >
      {label}
    </div>
  );
}

export default StatusWidget;
